import axios from "axios";

export const getUserReassignEmail = async (email:string, residentKey:string, contactKey:string) => {
    return await axios({
		url: `/User/ReassignEmail?email=${email}&residentKey=${residentKey}&contactKey=${contactKey}`,
		method: "GET",
	});
}